export type DocumentationMessages = {
  errorLoadingStatus: string;
  openOnboardingLink: string;
  accessOptionsInfo: string;
  identificationTitle: string;
  identificationInstructions: string;
  identificationBrowserOption: string;
  accountNotApprovedMessage: string;
  accountNotApprovedDescription: string;
};

export const documentationMessages: DocumentationMessages = {
  errorLoadingStatus: "Erro ao carregar o status. Por favor, tente novamente mais tarde.",
  openOnboardingLink: "Enviar",
  accessOptionsInfo:
    "Agora precisamos realizar sua identificação para aprovação de sua conta Talk2Pay.",
  identificationTitle: "Documentos de identificação",
  identificationInstructions:
    "1. Abra o aplicativo de câmera do seu celular.\n" +
    "2. Aponte seu celular para esta para escanar o QR code.\n" +
    "3. Siga as instruções para envio da documentação, tenha em mão seus documentos de identificação (CNH ou Documento de identidade).",
  identificationBrowserOption: "Realizar o processo de identificação pelo navegador",
  accountNotApprovedMessage: "Conta não aprovada",
  accountNotApprovedDescription: "A documentação estará disponível após a aprovação da conta Talk2Pay.",
};
